import { CheckCircleIcon, ExclamationTriangleIcon, XCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';

const configs = {
    success: { bg: 'bg-emerald-50 border-emerald-300 text-emerald-900', Icon: CheckCircleIcon },
    error: { bg: 'bg-red-50 border-red-200 text-red-800', Icon: XCircleIcon },
    warning: { bg: 'bg-amber-50 border-amber-200 text-amber-800', Icon: ExclamationTriangleIcon },
    info: { bg: 'bg-blue-50 border-blue-200 text-blue-800', Icon: InformationCircleIcon },
};

export default function Alert({ type = 'info', children, className = '' }) {
    const { bg, Icon } = configs[type] || configs.info;
    return (
        <div className={`flex items-start gap-3 p-4 rounded-xl border ${bg} ${className}`}>
            <Icon className="w-5 h-5 flex-shrink-0 mt-0.5" />
            <div className="text-sm">{children}</div>
        </div>
    );
}
